import { Volume2, VolumeX, Sun, Moon } from "lucide-react";
import { SurvivalCountdown } from "./SurvivalCountdown";
import { sound } from "./sound";

/** P0 S1: custom geometric rocket/arrow mark — one color + one cyan accent. */
const GmhMark = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <path d="M12 1.5 L19.5 21 L12 16.2 L4.5 21 Z" fill="currentColor" />
    <circle cx="12" cy="21.5" r="1.7" fill="#35e0f0" />
  </svg>
);

export const FUEL_GOAL = 10000;

const fmt = (n) => `$${Number(n || 0).toLocaleString("en-US")}`;

export const Navbar = ({
  total = 0,
  onOpenBid,
  onToggleTheme,
  onToggleMusic,
  musicOn,
  theme = "dark",
}) => (
  <nav className="sticky top-0 z-50 border-b border-[#141d34] bg-[#060a13]/85 backdrop-blur-md">
    <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:px-6">
      <div className="flex items-center gap-3">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 text-gmh-orange" aria-label="GetMeHome.lol home">
          <GmhMark size={18} />
        </a>
        <span data-testid="nav-mark" className="hidden text-lg font-semibold tracking-tight text-gmh-orange sm:inline">
          GetMeHome
        </span>
      </div>

      <div
        data-testid="nav-status"
        className="mono flex items-center gap-2 text-[10px] tracking-[0.12em] sm:gap-8 sm:text-xs sm:tracking-[0.2em]"
      >
        <SurvivalCountdown
          variant="compact"
          className="flex whitespace-nowrap"
        />
        <span data-testid="nav-fuel" className="font-semibold text-gmh-cyan">
          {fmt(total)} <span className="hidden opacity-60 sm:inline">/ $10K</span>
        </span>
      </div>

      <div className="flex items-center gap-2 text-slate-400 sm:gap-3">
        <button
          data-testid="navbar-transmit-btn"
          onClick={() => { sound.blip(); onOpenBid(); }}
          title="Transmit fuel"
          className="mono flex h-8 items-center gap-1.5 rounded-md border border-gmh-orange/60 bg-gmh-orange/15 px-2 text-xs font-bold tracking-[0.15em] text-gmh-orange transition-all hover:bg-gmh-orange hover:text-[#060a13] sm:px-3"
        >
          <GmhMark size={13} />
          TRANSMIT
        </button>
        <button
          data-testid="theme-toggle-btn"
          onClick={onToggleTheme}
          title={theme === "dark" ? "Switch theme" : "Switch theme"}
          aria-label="Toggle theme"
          className="flex h-8 w-8 items-center justify-center rounded-full border border-[#1c2740] transition-all hover:border-gmh-cyan/50 hover:text-gmh-cyan"
        >
          {theme === "dark" ? <Sun size={14} /> : <Moon size={14} />}
        </button>
        <button
          data-testid="music-toggle-btn"
          onClick={onToggleMusic}
          title="Ambient transmission audio"
          aria-label="Toggle sound"
          aria-pressed={musicOn ? "true" : "false"}
          className={`flex h-8 w-8 items-center justify-center rounded-full border transition-all ${
            musicOn
              ? "border-gmh-cyan bg-gmh-cyan/10 text-gmh-cyan shadow-[0_0_14px_rgba(53,224,240,0.35)]"
              : "border-[#1c2740] hover:border-gmh-cyan/50 hover:text-gmh-cyan"
          }`}
        >
          {musicOn ? <Volume2 size={14} /> : <VolumeX size={14} />}
        </button>
      </div>
    </div>
  </nav>
);
